export default "__VITE_ASSET__f03769e2__"